export const saveLPTokens = (chainId, walletAddress, lpData) => {
  const key = `lp_tokens_${chainId}_${walletAddress}`;
  localStorage.setItem(key, JSON.stringify(lpData));
};

export const loadLPTokens = (chainId, walletAddress) => {
  const key = `lp_tokens_${chainId}_${walletAddress}`;
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : [];
};

export const updateLPBalance = (chainId, walletAddress, pairAddress, balance) => {
  const lpTokens = loadLPTokens(chainId, walletAddress);
  const updated = lpTokens.map((lp) =>
    lp.pairAddress === pairAddress ? { ...lp, balance: balance.toString() } : lp
  );
  saveLPTokens(chainId, walletAddress, updated);
};

export const addLPToken = (chainId, walletAddress, lpInfo) => {
  const lpTokens = loadLPTokens(chainId, walletAddress);
  lpTokens.push(lpInfo);
  saveLPTokens(chainId, walletAddress, lpTokens);
};

export const removeLPToken = (chainId, walletAddress, pairAddress) => {
  const lpTokens = loadLPTokens(chainId, walletAddress);
  const updated = lpTokens.filter((lp) => lp.pairAddress !== pairAddress);
  saveLPTokens(chainId, walletAddress, updated);
};